/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
// import * as wjCore from "@grapecity/wijmo"
// import * as wjGrid from "@grapecity/wijmo.grid"
// import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import { showInfoToast } from "../../../components/CustomToast"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import DateInput from "../../../components/InputWrapper/DateInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import { メニューコード } from "../../../constant/menuCode"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import { TZyomuinListItem } from "../../../service/driver/TZyomuin"
import ZyomuinService from "../../../service/driver/zyomuinService"

import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import dateUtil from "../../../ts/util/dateUtil"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"

import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import commonUtil from "../../../ts/util/commonUtil"
import stringUtil from "../../../ts/util/stringUtil"
import EmptyTextHeader from "../../../components/FlexGridWrapper/EmptyTextHeader"
import lodash from "lodash"
import {
  TKenkoSindanKanriGetRes,
  TKenkoSindanKanriPostReq,
  TKenkoSindanKanriPutReq,
  TKenkoSindanZissiReq,
  T健康診断管理,
} from "../../../service/driver/kenkoSindan/TKenkoSindan"
import KenkoSindanService from "../../../service/driver/kenkoSindan/kenkoSindanService"
import KenkoSindanKanriSearchModal from "../../../components/SearchModal/KenkoSindanKanriSearchModal"

type TGridItem = TKenkoSindanZissiReq & {
  row_id: string
  社員氏名: string
  社員コード: string
  部所略称: string
}

/**
 * 健康診断登録
 * @returns
 */
const KenkoSindanRegister = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const isNewMode = (id ?? 0) === 0
  const disPatch: AppDispatch = useDispatch()

  const { eigyobiStr: 営業日 } = useSelector((state: RootState) => state.date)

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  const [乗務員ItemSource, set乗務員ItemSource] = useState<TZyomuinListItem[]>()

  // 表示項目のstate
  const [管理No, set管理No] = useState<string>()

  const [受診日, set受診日] = useState<string | null | undefined>(
    dateUtil.format(営業日)
  )
  const [医療機関, set医療機関] = useState<string>("")

  const [最終更新日時, set最終更新日時] = useState<string>("")
  const [更新対象元Resデータ, set更新対象元Resデータ] =
    useState<T健康診断管理>()

  // Grid用State
  const [flexGridFrom, setFlexGridFrom] = useState<wjGrid.FlexGrid>()
  const [flexGridTo, setFlexGridTo] = useState<wjGrid.FlexGrid>()

  const [gridDataFrom, setGridDataFrom] = useState<{
    data: wjCore.CollectionView<TGridItem>
  }>({ data: new wjCore.CollectionView<TGridItem>([]) })
  const [gridDataTo, setGridDataTo] = useState<{
    data: wjCore.CollectionView<TGridItem>
  }>({ data: new wjCore.CollectionView<TGridItem>([]) })

  const [isRestoreSearchingFrom, setIsRestoreSearchingFrom] =
    useState<boolean>(false)
  const [isRestoreSearchingTo, setIsRestoreSearchingTo] =
    useState<boolean>(false)

  const [gridInitializedFrom, setGridInitializedFrom] = useState<boolean>(false)
  const [gridInitializedTo, setGridInitializedTo] = useState<boolean>(false)

  // comboboxState

  // init
  const [isDataLoaded, setIsDataLoaded] = useState(false)

  const [isComponentInit, setIsComponentInit] = useState(false)

  const [
    isKenkoSindanKanriSelectModalShow,
    setIsKenkoSindanKanriSelectModalShow,
  ] = useState(false)
  const [isConfirmNewModalShow, setIsConfirmNewModalShow] = useState(false)
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] =
    useState(false)

  //　エラー表示用フラグ
  const [isInvalid医療機関, setIsInvalid医療機関] = useState<boolean>(false)
  const [isInvalid受診日, setIsInvalid受診日] = useState<boolean>(false)

  //#endregion

  //#region [method]
  /**
   * データ取得
   */
  const getData = async (id: number) => {
    const service = new KenkoSindanService()

    try {
      const res = await service.get(id)
      if (res.data) {
        set管理No(res.data.管理NO)
        set医療機関(res.data.医療機関)
        set受診日(res.data.受診日)
        set最終更新日時(res.data.更新日時 ? res.data.更新日時 : "")

        set更新対象元Resデータ(res.data)
      }

      updateCollectionView(乗務員ItemSource ?? [], res.data)
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    clearError()
    let isError = false

    const エラーメッセージList: string[] = []

    // 必須チェック
    if (stringUtil.isNullOrWhiteSpace(医療機関)) {
      setIsInvalid医療機関(true)
      エラーメッセージList.push("医療機関は必須入力です")
      isError = true
    }
    if (stringUtil.isNullOrWhiteSpace(受診日)) {
      setIsInvalid受診日(true)
      エラーメッセージList.push("受診日は必須入力です")
      isError = true
    }

    // 受診者チェック
    const has有効受診者データ = get実施情報ReqList().some(
      (r) => r.削除フラグ === 0
    )
    if (!has有効受診者データ) {
      エラーメッセージList.push("受診者を選択してください")
      isError = true
    }

    if (isError) {
      disPatch(setWarningAlerts(エラーメッセージList))
      return
    }

    setIsConfirmModalShow(true)
  }

  const clearError = () => {
    disPatch(clearAlert())
    setIsInvalid医療機関(false)
    setIsInvalid受診日(false)
  }

  const get実施情報ReqList = () => {
    const retList: TKenkoSindanZissiReq[] = []
    const fromSource: TGridItem[] = gridDataFrom.data.sourceCollection
    const toSource: TGridItem[] = gridDataTo.data.sourceCollection

    // from側から削除対象を抽出
    fromSource.forEach((item) => {
      if (item.健康診断実施ID != null)
        retList.push({
          健康診断実施ID: item.健康診断実施ID,
          社員ID: item.社員ID,
          削除フラグ: 1,
          更新日時: item.更新日時,
        })
    })

    toSource.forEach((item) => {
      if (item.健康診断実施ID == null) {
        retList.push({
          社員ID: item.社員ID,
          削除フラグ: 0,
        })
      } else {
        retList.push({
          健康診断実施ID: item.健康診断実施ID,
          社員ID: item.社員ID,
          削除フラグ: 0,
          更新日時: item.更新日時,
        })
      }
    })
    return retList
  }

  const getPostReq = (): TKenkoSindanKanriPostReq => {
    return {
      受診日: 受診日 ?? "",
      医療機関: 医療機関 ?? "",
      実施情報List: get実施情報ReqList(),
    }
  }

  const getPutReq = (): TKenkoSindanKanriPutReq => {
    return {
      受診日: 受診日 ?? "",
      医療機関: 医療機関 ?? "",
      実施情報List: get実施情報ReqList(),
      更新日時: 最終更新日時,
    }
  }

  /**
   * 削除
   */
  const deleteData = async () => {
    try {
      if (更新対象元Resデータ == null) return

      const service = new KenkoSindanService()
      const res = await service.deleteKenkoSindan(
        更新対象元Resデータ.健康診断管理ID,
        更新対象元Resデータ.更新日時
      )

      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(
          `管理No:${更新対象元Resデータ.管理NO}の削除が完了しました`
        )
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
      setIsConfirmDeleteModalShow(false)
    }
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      const service = new KenkoSindanService()

      let res: TApiResponse<boolean>
      if (id) {
        res = await service.putKenkoSindan(id, getPutReq())
      } else {
        res = await service.postKenkoSindan(getPostReq())
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(
          id
            ? `管理No:${更新対象元Resデータ!.管理NO}の更新が完了しました`
            : `新規登録が完了しました`
        )
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
      setIsConfirmDeleteModalShow(false)
    }
  }

  /**
   * FromとToのCollectionView更新
   * @param 乗務員List
   * @param 更新対象元Resデータ
   */
  const updateCollectionView = (
    乗務員List: TZyomuinListItem[],
    更新対象元Resデータ?: TKenkoSindanKanriGetRes
  ) => {
    let fromDataList: TGridItem[] = []
    let toDataList: TGridItem[] = []

    // 既存データがある場合
    if (更新対象元Resデータ != null) {
      const toData = 更新対象元Resデータ.実施情報List.map((item): TGridItem => {
        return {
          row_id: commonUtil.getUniqueStr(),
          社員ID: item.社員ID,
          健康診断実施ID: item.健康診断実施ID,
          社員コード: item.社員コード,
          社員氏名: item.社員氏名,
          部所略称: item.部所略称,
          更新日時: item.更新日時,
          削除フラグ: 0,
        }
      })
      toDataList = toData

      // toDataに存在しない乗務員をfromData側に作成
      const fromData = 乗務員List
        .filter((z) => !toDataList.some((toItem) => toItem.社員ID === z.社員ID))
        .map((z): TGridItem => {
          return {
            row_id: commonUtil.getUniqueStr(),
            社員ID: z.社員ID,
            社員コード: z.社員コード,
            社員氏名: z.社員氏名,
            部所略称: z.部所略称,
            削除フラグ: 0,
          }
        })
      fromDataList = fromData
    } else {
      // 部所乗務員をFrom側に設定
      const fromData = 乗務員List.map((z): TGridItem => {
        return {
          row_id: commonUtil.getUniqueStr(),
          社員ID: z.社員ID,
          社員コード: z.社員コード,
          社員氏名: z.社員氏名,
          部所略称: z.部所略称,
          削除フラグ: 0,
        }
      })
      fromDataList = fromData
    }

    const fromCv = new wjCore.CollectionView<TGridItem>(fromDataList)
    fromCv.filter = (item: TGridItem) => item.削除フラグ === 0

    const toCv = new wjCore.CollectionView<TGridItem>(toDataList)
    toCv.filter = (item: TGridItem) => item.削除フラグ === 0

    setGridDataFrom({ data: fromCv })
    setGridDataTo({ data: toCv })
  }

  const moveRight = (rightItem: TGridItem) => {
    const fromCv = gridDataFrom.data
    const fromDataList: TGridItem[] = fromCv.sourceCollection
    const fromData = fromDataList.find((ti) => rightItem.社員ID === ti.社員ID)
    const toCv = gridDataTo.data
    // const toDataList: TGridItem[] = toCv.sourceCollection
    // const toData = toDataList.find((ti) => rightItem.社員ID === ti.社員ID)

    // FROM側処理
    if (fromData != null) fromCv.remove(fromData)

    // TO側処理
    toCv.beginUpdate()
    toCv.addNew(fromData)
    toCv.commitNew()
    toCv.endUpdate()

    fromCv?.refresh()
    toCv?.refresh()
  }

  const moveLeft = (leftItem: TGridItem) => {
    const fromCv = gridDataFrom.data
    // const fromDataList: TGridItem[] = fromCv.sourceCollection
    // const fromData = fromDataList.find((ti) => leftItem.社員ID === ti.社員ID)
    const toCv = gridDataTo.data
    const toDataList: TGridItem[] = toCv.sourceCollection
    const toData = toDataList.find((ti) => leftItem.社員ID === ti.社員ID)

    // TO側処理
    if (toData != null) toCv.remove(toData)

    // FROM側処理
    fromCv.beginUpdate()
    fromCv.addNew(toData)
    fromCv.commitNew()
    fromCv.endUpdate()

    fromCv.refresh()
    toCv.refresh()
  }

  //#endregion

  //#region [effect]

  // 初期データ読み込み
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    const abortController = new AbortController()

    Promise.all([
      // 退職以外全員取得
      new ZyomuinService().getList({ 退職フラグ: 0 }),
    ])
      .then(([乗務員ListRes]) => {
        set乗務員ItemSource(乗務員ListRes.data)

        setIsDataLoaded(true)
      })
      .catch((err) => {
        disPatch(setAlerts(err))
        disPatch(画面ロック解除())
      })

    return () => {
      abortController.abort()
    }
  }, [])

  // コンポーネント初期化
  useEffect(() => {
    // データロードが先
    if (!isDataLoaded) return

    // 各種コンポーネントの初期化確認

    // 初期化完了
    setIsComponentInit(true)
  }, [isDataLoaded])

  // 編集データ読み込み
  useEffect(() => {
    if (!isDataLoaded) return
    if (!isComponentInit) return

    if (id) {
      // 既存データ編集
      getData(id)
        .finally(() => {
          setIsDataLoaded(true)
          disPatch(画面ロック解除())
          // ファイルロード後、戻るボタン押下時に警告が出るように変更
          isPrompt.current = true
        })
        .catch((err) => {
          disPatch(setAlerts(err))
        })
    } else {
      updateCollectionView(乗務員ItemSource ?? [], 更新対象元Resデータ)

      // 新規登録
      setIsDataLoaded(true)
      disPatch(画面ロック解除())
      // ファイルロード後、戻るボタン押下時に警告が出るように変更
      isPrompt.current = true
    }
  }, [isDataLoaded, isComponentInit])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">健康診断{id ? `更新` : `登録`}</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row className="search-button mb-2">
          <Col>
            <Button
              size="lg"
              type="button"
              disabled={isNewMode}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIsConfirmNewModalShow(true)
              }}>
              新規登録
            </Button>
            <Button
              size="lg"
              className="ms-5"
              type="button"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIsKenkoSindanKanriSelectModalShow(true)
              }}>
              登録修正
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 登録カード */}
            <Card className="w-60rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 管理No */}
                  <MasterRegisterFormRow label="管理No" isRequired={true}>
                    <TextInput
                      id="管理No"
                      name="管理No"
                      isReadOnly={true}
                      value={管理No}
                      setValue={set管理No}
                    />
                  </MasterRegisterFormRow>
                  {/* 医療機関 */}
                  <MasterRegisterFormRow label="医療機関" isRequired={true}>
                    <TextInput
                      id="医療機関"
                      name="医療機関"
                      className={isInvalid医療機関 ? "is-error" : ""}
                      value={医療機関}
                      setValue={set医療機関}></TextInput>
                  </MasterRegisterFormRow>
                  {/* 受診日 */}
                  <MasterRegisterFormRow label="受診日" isRequired={true}>
                    <DateInput
                      id="受診日"
                      placeholder="受診日"
                      className={isInvalid受診日 ? "is-error" : ""}
                      isRequired={true}
                      value={受診日}
                      defaultValue={営業日}
                      setValue={(v) => {
                        set受診日(v)
                      }}></DateInput>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          {/* From(Left)FlexGrid */}
          <Col className="max-w-40rem  always-scrollbars">
            <FlexGridOuter
              flexGrid={flexGridFrom}
              setFlexGrid={setFlexGridFrom}
              gridConstantProperties={
                CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS
              }
              gridData={gridDataFrom}
              setGridData={setGridDataFrom}
              style={{ height: "30rem" }}
              pageNumber={0}
              gridId={"AnzenKanriRegister_GridFrom"}
              isRestoreSearching={isRestoreSearchingFrom}
              setIsRestoreSearching={setIsRestoreSearchingFrom}
              gridInitialized={gridInitializedFrom}
              setGridInitialized={setGridInitializedFrom}
              pageSize={0}
              setPageSize={() => {}}
              headerComponent={
                <div
                  className="d-flex align-items-center"
                  style={{ height: "2.5rem" }}>
                  <label>候補者</label>
                </div>
              }
              isShowGridRowPickupButton={false}
              isShowGridFooter={false}>
              <wjrGrid.FlexGridColumn
                binding="社員コード"
                width={80}
                sortMemberPath="sort_社員コード"
                header="社員CD"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="社員氏名"
                width={128}
                header="氏名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={140}
                header="部所"
                binding="部所略称"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="選択"
                align={"center"}
                binding="社員ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(context: TWijmoCellTemplateContext<TGridItem>) => (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        moveRight(context.item)
                      }}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
            </FlexGridOuter>
          </Col>
          {/* To(Right)FlexGrid */}
          <Col className="max-w-40rem always-scrollbars">
            <FlexGridOuter
              flexGrid={flexGridTo}
              setFlexGrid={setFlexGridTo}
              gridConstantProperties={
                CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS
              }
              gridData={gridDataTo}
              setGridData={setGridDataTo}
              style={{ height: "30rem" }}
              pageNumber={0}
              gridId={"AnzenKanriRegister_GridTo"}
              isRestoreSearching={isRestoreSearchingTo}
              setIsRestoreSearching={setIsRestoreSearchingTo}
              gridInitialized={gridInitializedTo}
              setGridInitialized={setGridInitializedTo}
              pageSize={0}
              setPageSize={() => {}}
              headerComponent={
                <div
                  className="d-flex align-items-center"
                  style={{ height: "2.5rem" }}>
                  <label>受診者</label>
                </div>
              }
              isShowGridRowPickupButton={false}
              isShowGridFooter={false}>
              <wjrGrid.FlexGridColumn
                binding="社員コード"
                width={80}
                sortMemberPath="sort_社員コード"
                header="社員CD"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="社員氏名"
                width={128}
                header="氏名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={140}
                header="部所"
                binding="部所略称"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="削除"
                align={"center"}
                binding="乗務員ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(context: TWijmoCellTemplateContext<TGridItem>) => (
                    <Button
                      variant="caution"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        moveLeft(context.item)
                      }}>
                      削除
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
            </FlexGridOuter>
          </Col>
        </Row>
        <Row className="search-button">
          <Col>
            <Button
              type="submit"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
              }}>
              {id ? `更新` : `登録`}
            </Button>
            <Button
              className="ms-2"
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
            {id && (
              <Button
                className="ms-5"
                type="button"
                variant="caution"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setIsConfirmDeleteModalShow(true)
                }}>
                削除
              </Button>
            )}
          </Col>
        </Row>
      </Container>
      {/* 新規登録 */}
      <ConfirmModal
        isShow={isConfirmNewModalShow}
        hideHandler={setIsConfirmNewModalShow}
        submitHandler={(e) => {
          e.stopPropagation()
          e.preventDefault()

          isPrompt.current = false
          setIsConfirmNewModalShow(false)

          // isPrompt.currentオフ対策
          setTimeout(() => {
            const url = util.getMenuPath(
              メニューコード.乗務員管理.健康診断登録
            )[0]
            history.replace(url)
          }, 10)
        }}>
        新規登録画面に遷移しますか？
      </ConfirmModal>
      {/* 登録更新 */}
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={(e) => {
          e.stopPropagation()
          e.preventDefault()
          submit()
        }}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      {/* 削除 */}
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={(e) => {
          e.stopPropagation()
          e.preventDefault()
          // 削除フラグとして引数1を渡す。
          deleteData()
        }}>
        <>管理No:{更新対象元Resデータ?.管理NO}を削除しますか？</>
      </ConfirmModal>
      <KenkoSindanKanriSearchModal
        isShow={isKenkoSindanKanriSelectModalShow}
        setIsShow={setIsKenkoSindanKanriSelectModalShow}
        setItem={(selectedItem) => {
          isPrompt.current = false
          setIsKenkoSindanKanriSelectModalShow(false)

          // isPrompt.currentオフ対策
          setTimeout(() => {
            const baseUrl = util.getMenuPath(
              メニューコード.乗務員管理.健康診断登録
            )[0]
            const newUrl = `${lodash.trimEnd(
              baseUrl,
              "/"
            )}/${selectedItem.健康診断管理ID.toString()}`

            const is新規登録画面から遷移 = history.location.pathname === baseUrl

            history.replace(newUrl)

            // 新規登録画面から遷移していない場合（id:3からid:4のような)
            if (!is新規登録画面から遷移) {
              // 同一パスと見られてコンポーネントが再作成されないため、強制リロード
              history.go(0)
            }
          }, 10)
        }}></KenkoSindanKanriSearchModal>
    </>
  )
}

export default KenkoSindanRegister
